<template>
  <div class="pt-0 md:pt-16 h-screen bg-primary">
    <div class="max-w-xs mx-auto">
        <div class="text-center logo-container bg-primary mb-5"></div>
        <div class="text-center ml-0 text-2xl text-white bg-primary">Members Hub</div>

        <div class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 mt-4">
          <p class="text-center mb-4">Please wait while we attempt your login request.</p>
          <loader></loader>
        </div>
    </div>
  </div>
</template>

<script>
import api from '@/http'
export default {
  name: 'EasyPropertySSO',

  created () {
    if (this.isValidLoginRequest()) {
      this.getAccessToken()
    } else {
      this.$router.replace('/login')
    }
  },

  methods: {
    isValidLoginRequest () {
      let { ts, id, token } = this.$route.query

      return (ts && id && token)
    },

    getAccessToken () {
      api.get('/easyproperty/auth', {
        params: this.$route.query
      }).then(({ data }) => {
        if (data.error) {
          window.location = data.redirect_url
        } else {
          localStorage.setItem('accessToken', data.accessToken)
          localStorage.removeItem('refreshToken')
          this.$router.replace('/')
        }
      })
    }
  }
}
</script>

<style lang="sass" scoped>

</style>
